export default "__VITE_ASSET__482e9c0a__"